import React, { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Modal from "react-modal";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import moment from "moment";
import { convertToYYYYMMDD } from "../../common-data/Converts";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import MemberCheckinLogs from "../../pt-trials/common/MemberCheckinLogs";

const TrainerAttendanceTab = ({ tbDatas, isPage, setIsPage }) => {
  const initialClickValues = {
    userId: "",
    isModOpen: false,
    type: "",
    sendableStatsQPs: "",
  };
  const [clickValues, setClickValues] = useState(initialClickValues);

  const onCloseModal = () => {
    setClickValues(initialClickValues);
  };

  const tbColumns = [
    {
      dataField: "user_name",
      text: "Trainer",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.user_name || "NA"}

            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "account_type",
      text: "Shift Timing",
      formatter: (cell, row) => {
        const shiftTimings = row?.shift_details?.map((shift) => {
          const startTime = shift?.start_time
            ? moment(shift.start_time, "HH:mm").tz("Asia/Kolkata").format("h:mmA")
            : "";
          const endTime = shift?.end_time
            ? moment(shift.end_time, "HH:mm").tz("Asia/Kolkata").format("h:mmA")
            : "";
          return `${startTime}-${endTime}`;
        });

        const shiftTiming = shiftTimings
          ? shiftTimings?.join(", ")
          : "No Shift Found";

        return (
          <span
            className="tb-data minWidth150 link"
            onClick={() => {
              setClickValues((prevs) => ({
                ...prevs,
                userId: row?.user_id,
                isModOpen: true,
                type: "trainer",
                cardType: "last-checkin",
                sendableStatsQPs: `&start_date=${
                  row?.last_checkin ? convertToYYYYMMDD(row.last_checkin) : ""
                }&end_date=${
                  row?.last_checkin ? convertToYYYYMMDD(row.last_checkin) : ""
                }`,
              }));
            }}
          >
            {shiftTiming}
          </span>
        );
      },
    },
    {
      dataField: "checkin_date",
      text: "checkin date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.checkin_date || "-"}
          </span>
        );
      },
    },
    {
      dataField: "time",
      text: "checkin time",
      formatter: (cell, row) => {
        return <span className="tb-data minWidth90">{row?.time || "-"}</span>;
      },
    },
    {
      dataField: "checkout",
      text: "Last Punching Time",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth90">{row?.checkout || "-"}</span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Checkin Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer minWidth80vw">
          <ModalHeadAndClose
            title={`${clickValues.type} Checkin Logs`}
            onClose={onCloseModal}
          />

          <MemberCheckinLogs
            clickValues={clickValues}
            sendableStatsQPs={clickValues.sendableStatsQPs}
          />
        </div>
      </Modal>

      <div className="tab-view-table-container mt30">
        <Tabs>
          <TabList>
            <Tab>Trainer Checked In</Tab>
            <Tab>Trainer Not Checked In</Tab>
          </TabList>

          <TabPanel>
            <div className="overflowAuto separatedTable  mt30">
              <PaymentLinkTable
                tableData={tbDatas.allData}
                tableColumns={tbColumns}
                tablePagination={tbDatas.pagination}
                isPage={isPage}
                setIsPage={(value) => setIsPage(value)}
              />
            </div>
          </TabPanel>
        </Tabs>
      </div>
    </>
  );
};

export default TrainerAttendanceTab;
